import { Page, PageSkeleton } from '@/components';
import { useApi } from '@/api';
import { useSearchParams } from '@/hooks';
import { useParams } from 'react-router';
import {
  Flex,
  KpiCard,
  WalletAddress,
  KpiSkeleton,
  HeatmapSkeleton
} from '@blockanalitica/ui';
import { useNetwork } from '@/hooks';
import WalletActivity from './WalletActivity';

type WalletResponse = {
  address: string;
  name: string;
  market_symbol: string;
  market_underlying_address: string;
  market_address: string;
  wallet_address: string;
  supply: string | null;
};

export default function WalletPage() {
  const network = useNetwork();
  const { marketAddress, walletAddress } = useParams() as {
    marketAddress: string;
    walletAddress: string;
  };
  const [daysAgo] = useSearchParams('days_ago', '1');

  const [data, error] = useApi<WalletResponse>({
    url: `/markets/${marketAddress}/wallets/${walletAddress}/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap="xs" flexDirection={['column', 'row']}>
          <KpiSkeleton />
        </Flex>
        <HeatmapSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page
      title={
        <WalletAddress
          options={{
            name: 'Supplier',
            showCopyBtn: true,
            showEthScanLink: true,
            showDebankLink: true,
            sizes: {
              blockie: '6'
            }
          }}
          address={data.wallet_address}
        />
      }>
      <Flex gap="xs" flexDirection={['column', 'row']}>
        <Flex flexBasis={['100%', '50%']}>
          <KpiCard
            title="Supply"
            data={data}
            field="supply"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currencySize: '3',
                  currency: {
                    name: data.market_symbol,
                    address: data.market_underlying_address,
                    network: network
                  },
                  notation: 'compact'
                }
              }
            }}
          />
        </Flex>
      </Flex>
      <WalletActivity
        marketAddress={marketAddress}
        walletAddress={walletAddress}
      />
    </Page>
  );
}
